<template>
    <div class="pop-container">
        <div class="pop-content">
            <div class="close">
                <img src="/assets/images/close-icon.png" @click="closePop">
            </div>
            <div class="pop-title">
                选择服务
            </div>
            <div class="tabs-box">
                <div class="tabs" :class="{ active: tab.group == serviceGroup }" v-for="tab in modules" :key="tab.group"
                     @click="serviceTabChange(tab)">{{ tab.title }}
                </div>
            </div>
            <div class="pop-body">
                <div class="service-item" v-for="service in serviceList" :key="service.id"
                     @click="serviceChange(service)">
                    <div class="select">
                        <img src="/assets/images/card-template/card-template-icon11.png" v-if="service.select">
                        <div v-else></div>
                    </div>
                    <div class="thumb">
                        <img :src="service.thumb">
                    </div>
                    <div class="info-box">
                        <div class="info">
                            <div class="title">服务标题</div>
                            <div class="content">{{ service.title }}</div>
                        </div>
                        <div class="info" style="margin-top: 10px;">
                            <div class="title">服务介绍</div>
                            <div class="content">{{ service.summary }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="foot row">
                <div class="pagination-box row">
                    <a-pagination class="st-pagination" :current="pager.current" :total="pager.total"
                                  :pageSize="pager.pageSize" @change="gotoPage" v-if="pager.total > 0"/>
                    <div class="total">共{{ pager.total }}个服务，已选择{{ selectNum }}个</div>
                </div>
                <div class="btn" @click="selectServiceConfirm">确定</div>
            </div>
            
            <transition name="fadeIn">
                <div v-if="payTipsVisible" class="no-pay-tips">
                    <span class="circle-cutout"></span>
                    <span class="text">该产品未设置在线支付价格，暂时无法绑定</span>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import api from "@/repo/api";

export default {
    name: "SelectService",
    props: {
        group: {
            type: String,
            default: 'serve',
        },
        selects: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            services: this.selects,
            serviceList: [],
            serviceGroup: this.group,
            payTipsVisible: false,
            modules: [
                {
                    title: '服务',
                    group: 'serve',
                },
                {
                    title: '课程',
                    group: 'courses',
                },
                {
                    title: '活动',
                    group: 'activity',
                },
            ],
            query: {
                page: 1
            },
            pager: {
                current: 1,
                total: 0,
                pageSize: 10,
            },
            pendingServiceChanges: []
        }
    },
    computed: {
        selectNum() {
            // 创建一个临时集合来模拟最终的选择状态
            const selectedIds = new Set();
            
            // 首先添加所有当前已选择的服务
            this.services.forEach(service => {
                selectedIds.add(service.id);
            });
            
            // 然后按顺序应用pending操作
            this.pendingServiceChanges.forEach(change => {
                if (change.type === 'add') {
                    selectedIds.add(change.item.id);
                } else if (change.type === 'remove') {
                    selectedIds.delete(change.item.id);
                }
            });
            
            return selectedIds.size;
        }
    },
    mounted() {
        this.getServiceList();
    },
    methods: {
        gotoPage(page) {
            this.query.page = page;
            this.getServiceList();
        },
        serviceTabChange(tab) {
            this.pendingServiceChanges = [];
            this.serviceGroup = tab.group;
            this.getServiceList();
        },
        showPayInfoTips() {
            this.payTipsVisible = true;
            setTimeout(() => {
                this.payTipsVisible = false;
            }, 2000);
        },
        serviceChange(item) {
            
            if (!item.select) {
                
                if (!item.pay_amount || !item.pay_enabled) {
                    this.showPayInfoTips();
                    return;
                }
            }
            
            // 不再立即修改数据，而是记录操作到暂存数组
            if (item.select) {
                // 记录移除操作
                this.pendingServiceChanges.push({
                    type: 'remove',
                    item: item
                });
                // 只更新UI状态，不修改实际数据
                this.$set(item, 'select', false);
            } else {
                // 记录添加操作
                this.pendingServiceChanges.push({
                    type: 'add',
                    item: item
                });
                // 只更新UI状态，不修改实际数据
                this.$set(item, 'select', true);
            }
        },
        selectServiceConfirm() {
            let list = [];
            // 应用所有暂存的修改操作
            this.pendingServiceChanges.forEach(change => {
                if (change.type === 'add') {
                    // 添加到 services
                    if (this.services.findIndex(s => s.id === change.item.id) === -1) {
                        this.services.push(change.item);
                    }
                    // 添加到 extra.services
                    if (list.indexOf(change.item.id) === -1) {
                        list.push(change.item);
                    }
                } else if (change.type === 'remove') {
                    // 从 services 中移除
                    let index = this.services.findIndex(s => s.id === change.item.id);
                    if (index > -1) {
                        this.services.splice(index, 1);
                    }
                    // 从 extra.services 中移除
                    let idx = list.findIndex(s => s.id === change.item.id);
                    if (idx > -1) {
                        list.splice(idx, 1);
                    }
                }
            });
            console.log(list);
            this.$emit('confirm', {group: this.serviceGroup, list});
            this.closePop();
        },
        closePop() {
            this.$emit('closePop');
        },
        getServiceList() {
            this.query.group = this.serviceGroup;
            api.get('/course/list', this.query, (res) => {
                res.data.data.forEach(item => {
                    let index = this.services.findIndex(s => s.id === item.id);
                    if (index > -1) {
                        this.$set(item, 'select', true);
                    }
                })
                this.serviceList = res.data.data || [];
                this.pager.current = res.data.current_page;
                this.pager.total = res.data.total;
                this.pager.pageSize = res.data.per_page;
            })
        },
    }
}
</script>

<style lang="less" scoped>
.pop-container {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999999;
    display: flex;
    justify-content: center;
    align-items: center;
    
    .pop-content {
        width: 1368px;
        height: 810px;
        background: #fff;
        position: relative;
        
        .foot {
            width: 100%;
            height: 72px;
            border-top: 1px solid #EEEEEE;
            padding: 0 24px;
            justify-content: space-between;
            
            .pagination-box {
                color: #333333;
                font-size: 14px;
                
                .total {
                    margin-left: 16px;
                }
            }
        }
        
        .pop-body {
            width: 100%;
            height: calc(100% - 198px);
            margin-top: 16px;
            padding: 0 24px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-content: flex-start;
            overflow: scroll;
            overflow-x: hidden;
            
            .service-item {
                width: 648px;
                height: 180px;
                background: #FFFFFF;
                border: 1px solid #EEEEEE;
                display: flex;
                padding: 24px;
                cursor: pointer;
                position: relative;
                margin-bottom: 24px;
                user-select: none;
                
                .select {
                    width: 24px;
                    height: 24px;
                    position: absolute;
                    top: 16px;
                    right: 16px;
                    
                    img {
                        width: 24px;
                        height: 24px;
                    }
                    
                    div {
                        width: 24px;
                        height: 24px;
                        background: #FFFFFF;
                        border: 2px solid rgba(0, 0, 0, 0.4);
                        border-radius: 50%;
                    }
                }
                
                .sort-icon {
                    width: 40px;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: absolute;
                    top: 0;
                    right: 0;
                    cursor: pointer;
                    
                    img {
                        width: 16px;
                        height: 16px;
                    }
                }
                
                .del-icon {
                    width: 40px;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    cursor: pointer;
                    
                    img {
                        width: 16px;
                        height: 16px;
                    }
                }
                
                .thumb {
                    width: 224px;
                    height: 132px;
                    border: 1px solid #EEEEEE;
                    margin-right: 16px;
                    
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
                
                .info-box {
                    flex: 1;
                    
                    .info {
                        .title {
                            color: #999999;
                            font-size: 14px;
                            line-height: 20px;
                        }
                        
                        .content {
                            color: #333333;
                            font-size: 16px;
                            font-weight: 500;
                            line-height: 22px;
                            margin-top: 8px;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                            overflow: hidden;
                        }
                    }
                }
            }
        }
        
        .tabs-box {
            display: flex;
            align-items: center;
            margin-top: 16px;
            padding: 0 24px;
            
            .tabs {
                width: 92px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                background: #FFFFFF;
                border: 1px solid #EEEEEE;
                margin-right: 16px;
                cursor: default;
            }
            
            .active {
                color: #fff;
                background: #333333;
                border: 1px solid #333333;
            }
        }
        
        .pop-title {
            width: 100%;
            height: 62px;
            line-height: 62px;
            color: #333;
            font-size: 16px;
            font-weight: bold;
            padding-left: 24px;
            border-bottom: 1px solid #EEEEEE;
        }
        
        .close {
            width: 24px;
            height: 24px;
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            
            img {
                width: 100%;
                height: 100%;
            }
        }
    }
}

.row {
    display: flex;
    align-items: center;
}

.foot {
    width: 100%;
    height: 72px;
    border-top: 1px solid #EEEEEE;
    padding: 0 24px;
    justify-content: space-between;
    
    .pagination-box {
        color: #333333;
        font-size: 14px;
        
        .total {
            margin-left: 16px;
        }
    }
}

.no-pay-tips {
    background-color: #3D3D3D;
    border-radius: 12px;
    width: 472px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    
    .circle-cutout {
        width: 20px;
        height: 20px;
        background-color: rgb(251, 176, 59);
        border-radius: 50%;
        
        /* 核心逻辑：使用 mask 绘制一个圆，扣除中间的 X */
        /* 这里的原理是：利用 linear-gradient 画出两个透明的条纹交叉 */
        /* 注意：Mask 语法比较复杂，使用 SVG 作为 mask 是最稳健的方式 */
        
        -webkit-mask: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM16 14.59L14.59 16L12 13.41L9.41 16L8 14.59L10.59 12L8 9.41L9.41 8L12 10.59L14.59 8L16 9.41L13.41 12L16 14.59Z' fill='black'/%3E%3C/svg%3E") no-repeat center / contain;
        
        mask: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM16 14.59L14.59 16L12 13.41L9.41 16L8 14.59L10.59 12L8 9.41L9.41 8L12 10.59L14.59 8L16 9.41L13.41 12L16 14.59Z' fill='black'/%3E%3C/svg%3E") no-repeat center / contain;
    }
    
    .text {
        font-weight: 500;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 28px;
        margin-left: 10px;
    }
}
</style>